module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-INSTAGRAM.8d8a7cd8.png";